import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { ConnectionComponent } from './connection/connection.component';
import { ErrorComponent } from './error/error.component';
import { FatalComponent } from './fatal/fatal.component';
import { InfoComponent } from './info/info.component';
import { SuccessComponent } from './success/success.component';
import { WarningComponent } from './warning/warning.component';
import { MatDialogRef } from '@angular/material/dialog';
@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  isOpen = false;
  constructor(private snackBar: MatSnackBar) {}

  info(message: string) {
    const ref = this.snackBar.openFromComponent(InfoComponent, {
      duration: 2000,
      panelClass: 'info-snackbar',
      data: { message, action: 'Info' },
      verticalPosition: 'top'
    });
    this.handleEvents<InfoComponent>(ref);
    return ref.afterDismissed().toPromise();
  }

  success(message: string) {
    const ref = this.snackBar.openFromComponent(SuccessComponent, {
      duration: 2000,
      panelClass: 'success-snackbar',
      data: { message, action: 'Success' },
      verticalPosition: 'top'
    });
    this.handleEvents<SuccessComponent>(ref);
    return ref.afterDismissed().toPromise();
  }

  warning(message: string) {
    const ref = this.snackBar.openFromComponent(WarningComponent, {
      duration: 2000,
      panelClass: 'warning-snackbar',
      data: { message, action: 'Warning' },
      verticalPosition: 'top'
    });
    this.handleEvents<WarningComponent>(ref);
    return ref.afterDismissed().toPromise();
  }

  fatal(message: string) {
    const ref = this.snackBar.openFromComponent(FatalComponent, {
      duration: 2000,
      panelClass: 'fatal-snackbar',
      data: { message, action: 'Fatal' },
      verticalPosition: 'top'
    });
    this.handleEvents<FatalComponent>(ref);
    return ref.afterDismissed().toPromise();
  }

  // tslint:disable-next-line: no-any
  error(message: string, data: any = null) {
    const ref = this.snackBar.openFromComponent(ErrorComponent, {
      panelClass: 'error-snackbar',
      data: { message, action: 'Error', data },
      verticalPosition: 'top'
    });
    this.handleEvents<ErrorComponent>(ref);
    return ref.afterDismissed().toPromise();
  }

  connection(message: string) {
    const ref = this.snackBar.openFromComponent(ConnectionComponent, {
      duration: 5000,
      panelClass: 'connection',
      data: { message, action: 'Connection' },
      verticalPosition: 'top'
    });
    this.handleEvents<ConnectionComponent>(ref);
    return ref.afterDismissed().toPromise();
  }
  handleEvents<T>(ref: MatSnackBarRef<T>) {
    ref
      .afterOpened()
      .toPromise()
      .then(t => {
        this.isOpen = true;
      });
    ref
      .afterDismissed()
      .toPromise()
      .then(t => {
        this.isOpen = false;
      });
  }
  dismiss() {
    this.snackBar.dismiss();
  }
}
